import React from "react";
import * as Image from '../../../Assets/paymentIcon/index'
import './style.css'

const ThankYouCard = () => {
    return (
      <div className="thankyou-card">
        <img src={Image.congratulations} alt="Congratulation"/>
        <div>
          <img src={Image.thankyou_policy} alt="Thank You"/>
          <label>Payment Recieved</label>
        </div>
      </div>
    )
}

export default ThankYouCard